import React, { Component } from 'react'
import { View, Text } from '../react-native'
import { HighscoreApi } from '../helpers/DatabaseHelpers'

class ResultRanking extends Component{
  state = { entries: [] }

  componentWillMount(){
    HighscoreApi
      .orderByChild('orderer')
      .limitToLast(10)
      .once('value')
      .then(snapShoot => {
        const entries = []
        snapShoot.forEach(el => {
          entries.push(el.toJSON())
        })
        this.setState({ entries })
      })
  }

  render(){
    return (
      <View>
        <View>
          <Text style={styles.highScoreTitle}>High Score Rankings</Text>
        </View>
        <View style={styles.tableHeaderRow}>
          <Column width={150} name="Name" />
          <Column width={150} name="Score" />
          <Column width={200} name="Time" />
        </View>
        { this.state.entries.reverse().map(entry => (
          <View style={styles.tableBodyRow}>
            <Column width={150} name={entry.name} />
            <Column width={150} name={entry.score} />
            <Column width={200} name={`${entry.time/1000}s`} />
          </View>
        )) }
      </View>
    )
  }
}

const Column = ({ width, name }) => (
  <View style={{...styles.tableColumn, width }}>
    <Text>{ name }</Text>
  </View>
)

const styles = {
  highScoreTitle: { fontSize: 60 },
  tableHeaderRow: { display: 'flex', flexDirection: 'row', backgroundColor: 'grey' },
  tableBodyRow: { display: 'flex', flexDirection: 'row', backgroundColor: 'white', borderBottom: '1px solid red' },
  tableColumn: { textAlign: 'center', paddingTop: 5, paddingBottom: 5 },
}

export default ResultRanking



// WEBPACK FOOTER //
// ./src/components/ResultHanking.js